import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

function About() {
  const badgeRef = useRef(null);
  const headingRef = useRef(null);
  const subRef = useRef(null);
  const ctaRef = useRef(null);

  useEffect(() => {
    const els = [
      { el: badgeRef.current,   delay: 0   },
      { el: headingRef.current, delay: 120 },
      { el: subRef.current,     delay: 240 },
      { el: ctaRef.current,     delay: 360 },
    ];

    els.forEach(({ el, delay }) => {
      if (!el) return;
      el.style.opacity = '0';
      el.style.transform = 'translateY(18px)';
      el.style.transition = `opacity 0.6s ease ${delay}ms, transform 0.6s ease ${delay}ms`;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
        });
      });
    });
  }, []);

  return (
    <div className="mx-auto max-w-2xl py-32 sm:py-48 lg:py-16 static">
      <div ref={badgeRef} className="hidden sm:mb-8 sm:flex sm:justify-center">
        <div className="relative rounded-full px-3 py-1 text-sm/6 text-[#F5F5F5]/60 ring-1 ring-[#F5F5F5]/10 hover:ring-[#8B5CF6]/40 transition-all">
          The fastest and easiest way to create a fancy game name.{' '}
          <Link to="/creation" className="font-semibold text-[#8B5CF6]"><span aria-hidden="true" className="absolute inset-0" />
          Read Tutorial <span aria-hidden="true">&rarr;</span></Link>
        </div>
      </div>
      <div className="text-center">
        <h1 ref={headingRef} className="mb-4 text-4xl font-extrabold leading-none tracking-tight text-[#F5F5F5] md:text-5xl lg:text-6xl">
          Keep up with the latest name trends.
        </h1>
        <p ref={subRef} className="mt-8 text-lg font-medium text-pretty text-[#F5F5F5]/60 sm:text-xl/8">
          Use the names in games such as Counter-Strike 2, Fortnite, Valorant, ROBLOX, League of Legends and Dota 2, and more.
        </p>
        <div ref={ctaRef} className="mt-10 flex items-center justify-center gap-x-6">
          <Link to="/Create" className="rounded-md bg-[#8B5CF6] px-3.5 py-2.5 text-sm font-semibold text-[#F5F5F5] shadow-xs hover:bg-[#7C3AED] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8B5CF6] transition-colors">Get started</Link>
          <Link to="/creation" className="text-sm/6 font-semibold text-[#F5F5F5]/70 hover:text-[#8B5CF6] transition-colors">
            Learn more <span aria-hidden="true">→</span>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default About;
